module.exports = __webpack_public_path__ + "img/cloudIcon.c702e6e9.svg";